var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isShowCountdownBook)?_c('div',{staticClass:"boxCountdown text-center"},[_c('span',[_vm._v("Selesaikan pembayaran dalam waktu "+_vm._s(_vm.hour)+":"+_vm._s(_vm.minute)+":"+_vm._s(_vm.second))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }